import { ProductsCompany, CustomerType, Address, BasisType } from '@raskrask-dk/raskrask-utils'
import type { BookingflowStateMachine } from '../..'
import CalendarState from '../calendarState'
import type { CalendarStateDependencies } from '../calendarState/calendarState.types'
import CompanyLeadState from '../companyLeadState'
import type { CompanyLeadDependencies } from '../companyLeadState/companyState.types'
import { State } from '../state'
import type {
    CompanyProductPickActions,
    CompanyProductPickStateDependencies,
    IGetData,
} from './companyProductPickState.types'
import {
    companyProductPickActionz,
    companyProductPickActions,
} from './companyProductPickState.types'


const COMPANY_PRODUCT_PICK_STATE = 'COMPANY_PRODUCT_PICK_STATE'
export class CompanyProductPickState extends State<
    CompanyProductPickActions,
    typeof COMPANY_PRODUCT_PICK_STATE
> {
    public readonly type = COMPANY_PRODUCT_PICK_STATE
    private _productType: ProductsCompany | undefined
    private _address: Address
    private _basisType: BasisType
    private _customerType = 'Company' as CustomerType

    constructor(
        bfsm: BookingflowStateMachine,
        dependencies: CompanyProductPickStateDependencies
    ) {
        super(bfsm)
        const { address, basisType } = dependencies
        this._address = address
        this._basisType = basisType
    }

    private nextState():
        | CompanyProductPickState
        | CalendarState
        | CompanyLeadState {
        const productType = this._productType
        switch (productType) {
            case 'CompanyLead':
                return new CompanyLeadState(
                    this.bookingflowStateMachine,
                    this.leadDeps
                )
            case 'Booking':
                return new CalendarState(
                    this.bookingflowStateMachine,
                    this.calendarDeps
                )
            default:
                return this
        }
    }

    public doAction(
        action: CompanyProductPickActions
    ): CompanyProductPickState | CalendarState | CompanyLeadState {
        switch (action.type) {
            case 'NEXT_STATE':
                return this.nextState()
            case 'PICK_PRODUCT':
                this._productType = action.data
                return this
            default:
                return this
        }
    }

    public getActions = (): companyProductPickActions[] =>
        companyProductPickActionz.filter((action) =>
            new action(this).isDoable()
        )

    public getData(): IGetData {
        return {
            productType: this._productType,
            address: this._address,
            basisType: this._basisType,
            customerType: this._customerType,
        }
    }

    public unset(): void {
        return
    }

    public get product(): ProductsCompany | undefined {
        return this._productType
    }

    private get calendarDeps(): CalendarStateDependencies {
        return {
            address: this._address,
            basisType: this._basisType,
            customerType: 'Company',
        }
    }

    private get leadDeps(): CompanyLeadDependencies {
        return {
            address: this._address,
            basisType: this._basisType,
            productType: this._productType || 'CompanyLead',
        }
    }
}
